import axios from "axios";
import * as screenshot from "../../types/user/screenshot";
//import moment from "moment";
import dayjs from "dayjs";

//Screen Shot List
export const userScreenListAction =
  (companyId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: screenshot.USER_SCREENSHOT_LIST_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const body = {
        date: dayjs(date).format("YYYY-MM-DD"),
      };
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let companyId;
      if (sharedUserInfo?.payload?.company) {
        companyId = sharedUserInfo?.payload?.company?._id;
      } else if (sharedUserInfo?.empCompanies.length > 0) {
        companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
      }
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/screenshot/${companyId}/date`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: screenshot.USER_SCREENSHOT_LIST_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: screenshot.USER_SCREENSHOT_LIST_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Screen Shot List For Dashboard
export const userScreenDashListAction = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: screenshot.USER_DASHBOARD_SCREENSHOT_LIST_REQUEST,
    });
    const {
      sharedLogin: { sharedUserInfo },
    } = getState();
    const body = {
      date: dayjs(new Date()).format("YYYY-MM-DD"),
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${sharedUserInfo?.payload?.token}`,
      },
    };
    let companyId;
    if (sharedUserInfo?.payload?.company) {
      companyId = sharedUserInfo?.payload?.company?._id;
    } else if (sharedUserInfo?.empCompanies.length > 0) {
      companyId = sharedUserInfo?.empCompanies[0]?.companyId?._id;
    }
    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/user/screenshot/${companyId}/date`,
      body,
      config
    );
    // console.log(data);
    dispatch({
      type: screenshot.USER_DASHBOARD_SCREENSHOT_LIST_SUCCESS,
      payload: data?.data,
    });
  } catch (error) {
    let err =
      error.response &&
      (typeof error.response.data === "string"
        ? error.response.data
        : error.response.data.message
        ? error.response.data.message
        : error.response.data.errors
        ? error.response.data.errors[0].msg
        : error.message);
    if (!err) {
      err = "Network Error";
    }
    //  console.log(err);
    dispatch({
      type: screenshot.USER_DASHBOARD_SCREENSHOT_LIST_FAIL,
      payload: err,
    });
    throw Error(err);
  }
};

//Update Screen Shot
export const updateScreenReasonAction =
  (companyId, screenshotId, reason) => async (dispatch, getState) => {
    try {
      dispatch({
        type: screenshot.UPDATE_SCREENSHOT_REASON_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        reason,
        type: "blur",
      };
      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/screenshot/${companyId}/${screenshotId}/update`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: screenshot.UPDATE_SCREENSHOT_REASON_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: screenshot.UPDATE_SCREENSHOT_REASON_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };

//Delete Screen Shot
export const deleteScreenShotAction =
  (companyId, screenshotId, date) => async (dispatch, getState) => {
    try {
      dispatch({
        type: screenshot.DELETE_SCREENSHOT_REQUEST,
      });
      const {
        sharedLogin: { sharedUserInfo },
      } = getState();
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${sharedUserInfo?.payload?.token}`,
        },
      };
      let body = {
        date,
      };
      const { data } = await axios.post(
        `${process.env.REACT_APP_BACKEND_URI}/api/user/screenshot/${companyId}/${screenshotId}/delete`,
        body,
        config
      );
      // console.log(data);
      dispatch({
        type: screenshot.DELETE_SCREENSHOT_SUCCESS,
        payload: data?.data,
      });
    } catch (error) {
      let err =
        error.response &&
        (typeof error.response.data === "string"
          ? error.response.data
          : error.response.data.message
          ? error.response.data.message
          : error.response.data.errors
          ? error.response.data.errors[0].msg
          : error.message);
      if (!err) {
        err = "Network Error";
      }
      //  console.log(err);
      dispatch({
        type: screenshot.DELETE_SCREENSHOT_FAIL,
        payload: err,
      });
      throw Error(err);
    }
  };
